import { useState, useEffect } from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { Link } from 'react-router-dom';
import { Quote, Mail, Award, ChevronLeft, ChevronRight, Users } from 'lucide-react';

const AMBASSADOR = {
  name: "S.E. Balbina Malheiros da Silva",
  title: "Embaixadora Extraordinaria e Plenipotenciaria",
  photo: "https://customer-assets.emergentagent.com/job_792e387f-b4b3-43c6-bf9d-46ac5c601086/artifacts/ehbg8met_EmbajadoraES.png",
  biography: `Balbina Malheiros Dias da Silva (Luanda, 27 de fevereiro de 1959) e diplomata de carreira da Republica de Angola, com uma trajetoria consolidada no servico externo angolano e vasta experiencia em politica externa, cooperacao internacional e representacao diplomatica.

Formacao Academica

Entre 1981 e 1982, concluiu o curso de Relacoes Exteriores na Escola Nacional do Partido. Posteriormente, frequentou a Faculdade de Direito da Universidade Agostinho Neto, onde estudou ate 1984.
Em 1990, graduou-se em Ciencia Politica e Diplomacia pelo Instituto Rio Branco, em Brasilia, instituicao de referencia na formacao diplomatica.

Carreira Diplomatica

Ingressou no servico diplomatico angolano em 1983, tendo iniciado funcoes como adida diplomatica na Direcao para a America Latina e Caribe do Ministerio das Relacoes Exteriores.

Posteriormente, assumiu a chefia da Divisao do Norte de Africa e Medio Oriente, acumulando responsabilidades no acompanhamento das atividades da Organizacao da Unidade Africana.

Em 1993, foi nomeada Segunda-Secretaria na Embaixada de Angola em Harare, Republica do Zimbabue.
Em 1998, assumiu responsabilidades pelos Assuntos da Africa Austral no Ministerio das Relacoes Exteriores, e, no ano 2000, foi designada Chefe do Departamento da Europa Central e Oriental.

Tres anos mais tarde, foi nomeada Diretora do Departamento para as Americas, funcao estrategica no quadro da diplomacia angolana.

Entre 2012 e 2019, exerceu o cargo de Embaixadora Extraordinaria e Plenipotenciaria da Republica de Angola na Republica da Zambia.

Missao na Alemanha e Nova Nomeacao

Em 24 de outubro de 2019, foi acreditada como Embaixadora Extraordinaria e Plenipotenciaria da Republica de Angola na Republica Federal da Alemanha, tornando-se a primeira mulher angolana a chefiar a missao diplomatica em Berlim. Durante o seu mandato, acumulou igualmente a funcao de Embaixadora nao residente na Republica Checa.

Em 7 de fevereiro de 2025, por decisao de Sua Excelencia o Presidente da Republica, Joao Manuel Goncalves Lourenco, foi exonerada das funcoes na Alemanha e nomeada para o cargo de Embaixadora Extraordinaria e Plenipotenciaria da Republica de Angola no Reino de Espanha.

Perfil

Diplomata experiente e multilingue, fala portugues, frances, ingles e espanhol.
E casada e tem dedicado mais de quatro decadas ao servico da diplomacia angolana, contribuindo para o fortalecimento das relacoes bilaterais e multilaterais de Angola em diversos continentes.`,
  message: `"E com grande honra e responsabilidade que represento a Republica de Angola no Reino de Espanha. A nossa missao e fortalecer os lacos de amizade e cooperacao entre os nossos dois paises, ao mesmo tempo que servimos e apoiamos a comunidade angolana residente em Espanha.

A Embaixada esta empenhada em prestar servicos consulares de excelencia, promover a cultura angolana e facilitar o desenvolvimento das relacoes economicas e comerciais entre Angola e Espanha.

Convido todos os cidadaos angolanos a utilizarem os servicos da Embaixada e a participarem nas atividades que organizamos ao longo do ano. Juntos, construimos uma comunidade mais forte e unida."`
};

const FORMER_AMBASSADORS = [
  { name: "Fernando Jose de Franca Dias Van-Dunem", period: "1982 - 1985", photo: "https://customer-assets.emergentagent.com/job_792e387f-b4b3-43c6-bf9d-46ac5c601086/artifacts/5lhz0pi8_Fernando_Jose%CC%81_de_Franc%CC%A7a_Dias_Van-Du%CC%81nem_%281980%29.jpg", note: "Primeiro Embaixador de Angola em Espanha" },
  { name: "Mawete Joao Baptista", period: "1986 - 1989", photo: "https://customer-assets.emergentagent.com/job_792e387f-b4b3-43c6-bf9d-46ac5c601086/artifacts/sze57l9l_Mawete%20Joa%CC%83o%20Baptista.png", note: "Consolidacao das relacoes diplomaticas" },
  { name: "Kamu de Almeida", period: "1989 - 1993", photo: "https://customer-assets.emergentagent.com/job_792e387f-b4b3-43c6-bf9d-46ac5c601086/artifacts/p23i3eve_Kamu%20de%20Almeida.png", note: "Fortalecimento institucional" },
  { name: "Assuncao dos Anjos", period: "1993 - 2000", photo: "https://customer-assets.emergentagent.com/job_792e387f-b4b3-43c6-bf9d-46ac5c601086/artifacts/rmljavrg_assuncao%20dos%20anjos.jpg", note: "Periodo de transicao democratica" },
  { name: "General Pedro Sebastiao", period: "2000 - 2003", photo: "https://customer-assets.emergentagent.com/job_792e387f-b4b3-43c6-bf9d-46ac5c601086/artifacts/5wv3wp64_General%20Pedro%20Sebastia%CC%83o.jpeg", note: "Consolidacao da paz" },
  { name: "Armando da Cruz Neto", period: "2004 - 2006", photo: "https://customer-assets.emergentagent.com/job_792e387f-b4b3-43c6-bf9d-46ac5c601086/artifacts/w5sh9iby_General%20Armando%20da%20Cruz.jpeg", note: "Fortalecimento das relacoes economicas" },
  { name: "Victor Manuel Rita da Fonseca Lima", period: "2006 - 2017", photo: "https://customer-assets.emergentagent.com/job_792e387f-b4b3-43c6-bf9d-46ac5c601086/artifacts/kwuw8m5n_Victor%20Lima.jpeg", note: "Modernizacao dos servicos consulares" },
  { name: "Jose Luis de Matos Agostinho", period: "2018 - 2023", photo: "https://customer-assets.emergentagent.com/job_792e387f-b4b3-43c6-bf9d-46ac5c601086/artifacts/4rfvpc15_Jose%CC%81%20Lui%CC%81s%20de%20Matos%20Agostinho.jpeg", note: "Digitalizacao e aproximacao a comunidade" },
  { name: "Alfredo Dombe", period: "2023 - 2025", photo: "https://customer-assets.emergentagent.com/job_792e387f-b4b3-43c6-bf9d-46ac5c601086/artifacts/y1ilc7j5_Alfredo%20Dombe.jpeg", note: "Reforco das relacoes bilaterais" },
];

// Full org chart data
const ORG_SENIOR = [
  { name: 'Maria Emilia Almeida', role: 'Sra. Conselheira' },
  { name: 'Andre Domingos', role: 'Ministro-Conselheiro' },
];

const ORG_SECRETARY = { name: 'Waldemar de Carvalho', role: '2.o Secretario' };

const ORG_SECTORS = [
  {
    head: { name: 'Micolo', role: 'Adido de Seguranca' },
    technicians: [],
  },
  {
    head: { name: 'Jose Abranches', role: 'Adido Militar' },
    technicians: [],
  },
  {
    head: { name: 'Eleonor Conceicao', role: 'Adido Financeiro' },
    technicians: [
      { name: 'Fautina de Assis', role: 'Tecnico Sector Financeiro' },
      { name: 'Celia Moreno', role: 'Tecnico Sector Financeiro' },
    ],
  },
  {
    head: { name: 'Paula Cordeiro', role: 'Adido Comercial' },
    technicians: [],
  },
  {
    head: { name: 'Marlene Gomes', role: 'Adido de Imprensa e Cultura' },
    technicians: [],
  },
  {
    head: { name: 'Marineza Pascoal', role: 'Adido Administrativa' },
    technicians: [
      { name: 'Frida Gomes', role: 'Tecnico Sector Administrativo' },
      { name: 'Jose Almeida', role: 'Tecnico Sector Administrativo' },
      { name: 'Elena Lorente', role: 'Tecnico Sector Administrativo' },
      { name: 'Pilar Sastre', role: 'Tecnico Sector Administrativo' },
      { name: 'Concepcion Banos', role: 'Tecnico Sector Administrativo' },
    ],
  },
  {
    head: { name: 'Hedmilda Diogo de Carvalho', role: 'Sector Consular' },
    technicians: [
      { name: 'Antonio Guilherme', role: 'Tecnico Sector Consular' },
      { name: 'Candice dos Reis', role: 'Tecnico Sector Consular' },
    ],
  },
  {
    sectionLabel: 'Gab. Embaixadora',
    head: null,
    technicians: [
      { name: 'Ana do Nascimento', role: 'Gab. Embaixadora' },
      { name: 'Sandra Gourgel', role: 'Gab. Embaixadora' },
    ],
  },
  {
    sectionLabel: 'Gab. Informatica',
    head: null,
    technicians: [
      { name: 'Amilcar Quinga', role: 'Gab. Informatica' },
    ],
  },
];

function FormerAmbassadorsSlideshow() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  useEffect(() => {
    if (!isAutoPlaying) return;
    const timer = setInterval(() => {
      setCurrentIndex(i => (i + 1) % Math.ceil(FORMER_AMBASSADORS.length / 3));
    }, 5000);
    return () => clearInterval(timer);
  }, [isAutoPlaying]);

  const totalSlides = Math.ceil(FORMER_AMBASSADORS.length / 3);
  const visibleAmbassadors = FORMER_AMBASSADORS.slice(currentIndex * 3, currentIndex * 3 + 3);

  const goTo = (index) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const prev = () => goTo((currentIndex - 1 + totalSlides) % totalSlides);
  const next = () => goTo((currentIndex + 1) % totalSlides);

  return (
    <div className="relative" data-testid="former-ambassadors-slideshow">
      <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 w-10 h-10 bg-white shadow-lg rounded-full flex items-center justify-center text-gray-600 hover:text-[#CC0000] hover:shadow-xl transition-all hidden md:flex" data-testid="ambassadors-prev">
        <ChevronLeft size={20} />
      </button>
      <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 w-10 h-10 bg-white shadow-lg rounded-full flex items-center justify-center text-gray-600 hover:text-[#CC0000] hover:shadow-xl transition-all hidden md:flex" data-testid="ambassadors-next">
        <ChevronRight size={20} />
      </button>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 transition-all duration-500">
        {visibleAmbassadors.map((amb) => (
          <div key={amb.name} className="bg-white rounded-md border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow">
            <div className="relative h-56 bg-gray-100">
              <img src={amb.photo} alt={amb.name} className="w-full h-full object-cover object-top" />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                <span className="text-xs text-[#FFD700] font-semibold">{amb.period}</span>
              </div>
            </div>
            <div className="p-4">
              <h4 className="font-bold text-gray-900 text-sm mb-1">{amb.name}</h4>
              <p className="text-xs text-gray-500">{amb.note}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="flex justify-center gap-2 mt-6">
        {[...Array(totalSlides)].map((_, i) => (
          <button key={i} onClick={() => goTo(i)}
            className={`h-2 rounded-full transition-all ${i === currentIndex ? 'w-8 bg-[#CC0000]' : 'w-2 bg-gray-300 hover:bg-gray-400'}`} />
        ))}
      </div>
    </div>
  );
}

function PersonCard({ name, role, highlight, size = 'md' }) {
  const sizes = {
    lg: 'w-20 h-20',
    md: 'w-14 h-14',
    sm: 'w-11 h-11',
  };
  const textSizes = {
    lg: 'text-sm',
    md: 'text-xs',
    sm: 'text-[11px]',
  };
  const initials = name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase();

  return (
    <div className="flex flex-col items-center">
      <div className={`${sizes[size]} rounded-full flex items-center justify-center font-bold shadow-sm ${highlight ? 'bg-[#CC0000] text-white border-2 border-[#FFD700]' : 'bg-gray-100 text-gray-500 border-2 border-gray-200'}`}>
        <span className={size === 'sm' ? 'text-[10px]' : 'text-xs'}>{initials}</span>
      </div>
      <p className={`${textSizes[size]} font-semibold text-gray-900 mt-1.5 text-center leading-tight`}>{name}</p>
      <p className={`${size === 'sm' ? 'text-[9px]' : 'text-[10px]'} text-gray-500 text-center leading-tight`}>{role}</p>
    </div>
  );
}

function Connector({ vertical = true, height = 'h-6' }) {
  return vertical
    ? <div className={`w-0.5 ${height} bg-gray-300 mx-auto`} />
    : <div className="h-0.5 bg-gray-300 flex-1" />;
}

function OrgChartSection({ t }) {
  return (
    <div data-testid="org-chart" className="overflow-x-auto">
      <div className="min-w-[700px]">
        {/* Level 1: Ambassador */}
        <div className="flex flex-col items-center">
          <div className="relative">
            <img src={AMBASSADOR.photo} alt={AMBASSADOR.name}
              className="w-24 h-24 rounded-full object-cover object-top border-4 border-[#FFD700] shadow-lg" />
          </div>
          <h4 className="font-bold text-gray-900 mt-2 text-center text-sm">{AMBASSADOR.name}</h4>
          <p className="text-xs text-[#CC0000] font-semibold">Embaixadora</p>
          <Connector height="h-6" />
        </div>

        {/* Level 2: Senior Staff */}
        <div className="flex items-start justify-center gap-12 mb-2">
          {ORG_SENIOR.map((person) => (
            <div key={person.name} className="flex flex-col items-center">
              <Connector height="h-4" />
              <PersonCard name={person.name} role={person.role} highlight size="md" />
            </div>
          ))}
        </div>
        <Connector height="h-4" />

        {/* Level 3: 2nd Secretary */}
        <div className="flex justify-center mb-2">
          <PersonCard name={ORG_SECRETARY.name} role={ORG_SECRETARY.role} highlight size="md" />
        </div>
        <Connector height="h-4" />

        {/* Horizontal bar */}
        <div className="max-w-5xl mx-auto h-0.5 bg-gray-300" />

        {/* Level 4: Attachés & Sector Heads */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-4 gap-y-8 mt-2 max-w-5xl mx-auto">
          {ORG_SECTORS.map((sector, idx) => (
            <div key={idx} className="flex flex-col items-center">
              <Connector height="h-4" />
              {/* Sector label or head */}
              {sector.head ? (
                <div className="bg-[#CC0000] text-white rounded-md py-1.5 px-2 mb-2 w-full text-center">
                  <p className="text-[10px] font-bold leading-tight">{sector.head.role}</p>
                  <p className="text-[9px] font-medium opacity-90">{sector.head.name}</p>
                </div>
              ) : (
                <div className="bg-[#0A0A0A] text-white rounded-md py-1.5 px-2 mb-2 w-full text-center">
                  <p className="text-[10px] font-bold leading-tight">{sector.sectionLabel}</p>
                </div>
              )}
              {/* Technicians */}
              {sector.technicians.length > 0 && (
                <div className="space-y-2 w-full">
                  <Connector height="h-3" />
                  {sector.technicians.map((tech) => (
                    <div key={tech.name} className="bg-gray-50 border border-gray-200 rounded py-1.5 px-2 text-center">
                      <p className="text-[10px] font-semibold text-gray-800 leading-tight">{tech.name}</p>
                      <p className="text-[8px] text-gray-500">{tech.role}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function DiplomaticCorps() {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-white" data-testid="diplomatic-corps-page">
      {/* Hero */}
      <div className="bg-[#0A0A0A] text-white border-b-4 border-[#FFD700]">
        <div className="max-w-7xl mx-auto px-4 py-12">
          <p className="text-xs text-[#FFD700] font-semibold uppercase tracking-[0.2em] mb-3">{t('diplomatic.overline')}</p>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight font-serif">{t('diplomatic.title')}</h1>
          <p className="text-gray-400 mt-3 max-w-2xl">{t('diplomatic.subtitle')}</p>
        </div>
      </div>

      {/* Current Ambassador */}
      <section className="py-16 bg-white" data-testid="ambassador-section">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-10">
            <p className="text-xs text-[#CC0000] font-semibold uppercase tracking-[0.2em] mb-2">{t('about.head_of_mission')}</p>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 font-serif">{t('about.the_ambassador')}</h2>
            <div className="w-16 h-1 bg-[#CC0000] mx-auto mt-4" />
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-1">
              <div className="bg-gray-50 rounded-md p-6 text-center">
                <div className="relative inline-block mb-4">
                  <img src={AMBASSADOR.photo} alt={AMBASSADOR.name} className="w-48 h-48 rounded-full object-cover object-top border-4 border-[#FFD700] shadow-xl" />
                  <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 bg-[#CC0000] text-white px-4 py-1 rounded-full text-xs font-semibold">
                    <Award size={12} className="inline mr-1" />
                    {t('about.ambassador_label')}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-1">{AMBASSADOR.name}</h3>
                <p className="text-sm text-[#CC0000] font-medium mb-4">{AMBASSADOR.title}</p>
                <Link to="/contactos" className="inline-flex items-center gap-1 px-4 py-2 bg-[#CC0000] text-white text-sm font-medium rounded-sm hover:bg-[#A30000] transition-colors" data-testid="ambassador-contact-btn">
                  <Mail size={14} /> {t('about.contact')}
                </Link>
              </div>
            </div>
            
            <div className="lg:col-span-2 space-y-6">
              <div className="bg-white border border-gray-200 rounded-md p-6">
                <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                  <Users size={18} className="text-[#CC0000]" />
                  {t('about.biography')}
                </h4>
                <div className="text-sm text-gray-600 leading-relaxed whitespace-pre-line">
                  {AMBASSADOR.biography}
                </div>
              </div>
              
              <div className="bg-[#0A0A0A] text-white rounded-md p-6">
                <div className="flex items-start gap-3">
                  <Quote size={28} className="text-[#FFD700] flex-shrink-0 rotate-180" />
                  <div>
                    <h4 className="font-bold text-[#FFD700] mb-3">{t('about.ambassador_message')}</h4>
                    <div className="text-sm text-gray-300 leading-relaxed whitespace-pre-line italic">
                      {AMBASSADOR.message}
                    </div>
                    <p className="mt-4 text-right text-[#FFD700] font-semibold">- {AMBASSADOR.name}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Former Ambassadors */}
      <section className="py-16 bg-[#F9FAFB]">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-10">
            <p className="text-xs text-[#CC0000] font-semibold uppercase tracking-[0.2em] mb-2">{t('about.diplomatic_history')}</p>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 font-serif">{t('about.former_ambassadors')}</h2>
            <p className="text-gray-500 text-sm mt-2">{t('about.former_ambassadors_desc')}</p>
            <div className="w-16 h-1 bg-[#CC0000] mx-auto mt-4" />
          </div>
          <FormerAmbassadorsSlideshow />
        </div>
      </section>

      {/* Organigrama */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <p className="text-xs text-[#CC0000] font-semibold uppercase tracking-[0.2em] mb-2">{t('diplomatic.org_overline')}</p>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 font-serif">{t('diplomatic.org_title')}</h2>
            <p className="text-gray-500 text-sm mt-2">{t('diplomatic.org_subtitle')}</p>
            <div className="w-16 h-1 bg-[#CC0000] mx-auto mt-4" />
          </div>
          <OrgChartSection t={t} />
        </div>
      </section>
    </div>
  );
}
